import { CurriculumPickerModalController } from './curriculum-picker-modal.controller';
import { CurriculumPickerModalProps } from './curriculum-picker-modal.model';

export const CurriculumPickerModal = (props: CurriculumPickerModalProps) => {
  return <CurriculumPickerModalController {...props} />;
};
